import { render, staticRenderFns } from "./setting-company.vue?vue&type=template&id=07d906f8"
import script from "./setting-company.vue?vue&type=script&lang=js"
export * from "./setting-company.vue?vue&type=script&lang=js"
import style0 from "./setting-company.vue?vue&type=style&index=0&id=07d906f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports